export {
  alias,
  getAnonymousId,
  group,
  identify,
  init,
  page,
  reset,
  setAnonymousId,
  track,
  willRudderstackBeInitialised,
} from './lib/analytics';
export { EventQueue } from './lib/event-queue';
export {
  getActiveCategories,
  BASIC_ACTIVE_CATEGORIES_NUMBER,
} from './lib/oneTrust';

export type { Event } from './lib/event-queue';
export type {
  AnalyticsConfig,
  Method,
  WindowRudderstack,
} from './lib/analytics';
export type { OneTrustCategoryIds } from './lib/oneTrust';
